/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Delete_Loading_DescriptionInputs */

const es_admin_users_delete_loading_description = /** @type {(inputs: Admin_Users_Delete_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos eliminando el usuario. Por favor, esperá un momento.`)
};

const en_admin_users_delete_loading_description = /** @type {(inputs: Admin_Users_Delete_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are deleting the user. Please wait a moment.`)
};

/**
* | output |
* | --- |
* | "We are deleting the user. Please wait a moment." |
*
* @param {Admin_Users_Delete_Loading_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_delete_loading_description = /** @type {((inputs?: Admin_Users_Delete_Loading_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Delete_Loading_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_delete_loading_description(inputs)
	return en_admin_users_delete_loading_description(inputs)
});
export { admin_users_delete_loading_description as "admin.users.delete.loading.description" }